import React from 'react';

const useIsSkySlopeMobileApp = (): boolean => {
  const userAgent = typeof window.navigator === 'undefined' ? '' : navigator.userAgent;
  return React.useMemo(() => Boolean(userAgent.match(/MobileApp.*SkySlope/i)), [userAgent]);
};

export default useIsSkySlopeMobileApp;
